import * as React from "react";
import { useEffect } from "react";
import { useState } from "react";
// import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommercialDetails,
  fetchPreviousInsurers,
} from "../../../Redux/actions/CommercialSlice";
// import { GetPrevPolicy } from "../../Redux/actions/NumCaration";

import { Col, Form, Input, Row, Select, Button, DatePicker } from "antd/lib";
import PrevPolicyDisplay from "./PrevPolicyDisplay";
import moment from "moment";
import { setPrevPolicy } from "../../../Redux/actions/CommercialSlice";
function PreviousPolicyDetailCommer({ showStep4, setShowStep4 }) {
  // console.log("step2.... ", showStep4);
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const CommerDetail = useSelector(getCommercialDetails);
  const QuickQuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  const PrevPolDetails =
    CommerDetail?.prevPolicyDetail?.currentThirdPartyPolicy;
  // console.log(PrevPolDetails)
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  //   const [PrevPolDetails, setpolicyDetail] = useState(PrevPolDetails);
  const [selectedInsurer, setSelectedInsurer] = useState(
    PrevPolDetails?.prevInsurerName ? PrevPolDetails?.prevInsurerName : ""
  );
  const [selectedTPInsurer, setSelectedTPInsurer] = useState(
    PrevPolDetails?.prevInsurerName ? PrevPolDetails?.prevInsurerName : ""
  );

  // console.log("QuickQuoteInput", QuickQuoteInput);

  useEffect(() => {
    dispatch(fetchPreviousInsurers());
  }, [dispatch]);
  const disabledDate = (current) => {
    const currentDate = moment();
    const fiveMonthsFromNow = moment().add(25, "week");
    return (
      current &&
      (current < currentDate.endOf("day") ||
        current > fiveMonthsFromNow.endOf("day"))
    );
  };

  const onFinish = (values) => {
    setLoading(true);
    // console.log('values',values);
    const updatedPolicyDetail = {
      ...PrevPolDetails,
      previousInsurerCode: values?.previousInsurerCode,
      prevInsurerName: selectedInsurer,
      previousPolicyExpiryDate: moment(values?.previousPolicyExpiryDate).format(
        "YYYY-MM-DD"
      ),
      previousPolicyNumber: values?.policy_number,
      tpInsurerName: selectedTPInsurer,
      currentThirdPartyPolicy: PrevPolDetails?.currentThirdPartyPolicy
        ? {
            ...PrevPolDetails?.currentThirdPartyPolicy,
            isCurrentThirdPartyPolicyActive: null,
            currentThirdPartyPolicyNumber: values?.tp_policy_number,
            currentThirdPartyPolicyInsurerCode: values?.tpInsurerCompany,
            currentThirdPartyPolicyStartDateTime: moment(
              values?.tp_policy_start_date
            ).format("YYYY-MM-DD"),
            currentThirdPartyPolicyExpiryDateTime: moment(
              values?.tp_policy_end_date
            ).format("YYYY-MM-DD"),
          }
        : null,
    };
    dispatch(setPrevPolicy(updatedPolicyDetail));
    setTimeout(() => {
      setLoading(false);
      setShowStep4(true);
    }, 500);
  };
  const onFinishFailed = (values) => {
    console.log(values);
    form.scrollToField(values.errorFields[0].name);
  };
  return (
    <>
      {showStep4 ? (
        <PrevPolicyDisplay />
      ) : (
        <div className="gridparent-skb">
          <Form
            layout={formLayout}
            form={form}
            style={{ paddingTop: "10px" }}
            requiredMark={true}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  label="previous insurer"
                  name="previousInsurerCode"
                  rules={[
                    {
                      required: true,
                      message: "Please select previous insurer",
                    },
                  ]}
                  initialValue={PrevPolDetails?.previousInsurerCode}
                >
                  <Select
                    defaultValue="Select your option"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    options={CommerDetail?.previousInsurerList?.map((p) => ({
                      key: p.id,
                      value: p.code,
                      label: p.name,
                    }))}
                    onChange={(value, option) => {
                      console.log(value, option);
                      setSelectedInsurer(option?.label);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Policy Number"
                  name="policy_number"
                  rules={[
                    {
                      required: true,
                      message: "Please Input Policy Number",
                    },
                  ]}
                  initialValue={PrevPolDetails?.previousPolicyNumber}
                >
                  <Input
                    style={{ width: "100%", padding: "1px 10px" }}
                    placeholder="Policy Number"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Previous Policy Expiry Date"
                  name="previousPolicyExpiryDate"
                  rules={[
                    {
                      required: true,
                      message: "Please select Date",
                    },
                  ]}
                  initialValue={
                    PrevPolDetails?.previousPolicyExpiryDate
                      ? moment(QuickQuoteInput?.previousPolicyExpiryDate)
                      : null
                  }
                >
                  <DatePicker
                    style={{ width: "100%", padding: "8px 10px" }}
                    disabledDate={disabledDate}
                    format="YYYY-MM-DD"
                    placeholder="Select Expiry Date"
                  />
                </Form.Item>
              </Col>
            </Row>
            {QuickQuoteInput?.insuranceProductCode === "Bundled" ||
            QuickQuoteInput?.insuranceProductCode === "PVS" ? (
              <>
                <Row gutter={24}>
                  <div className="bundle-tp px-3 py-3">TP Details</div>
                </Row>
                <Row gutter={24} className="pt-3">
                  <Col span={8}>
                    <Form.Item
                      label="TP Insurer Company"
                      name="tpInsurerCompany"
                      rules={[
                        {
                          required: true,
                          message: "Please select TP insurer",
                        },
                      ]}
                      initialValue={PrevPolDetails?.previousInsurerCode}
                    >
                      <Select
                        defaultValue="Select your option"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={CommerDetail?.previousInsurerList?.map(
                          (p) => ({
                            key: p.id,
                            value: p.code,
                            label: p.name,
                          })
                        )}
                        onChange={(value, option) => {
                          console.log(value, option);
                          setSelectedTPInsurer(option?.label);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="TP Policy Number"
                      name="tp_policy_number"
                      rules={[
                        {
                          required: true,
                          message: "Please Input Policy Number",
                        },
                      ]}
                      initialValue={
                        PrevPolDetails?.currentThirdPartyPolicy
                          ?.currentThirdPartyPolicyNumber
                      }
                    >
                      <Input
                        style={{ width: "100%", padding: "1px 10px" }}
                        placeholder="Policy Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="TP Policy Start Date"
                      name="tp_policy_start_date"
                      rules={[
                        {
                          required: true,
                          message: "Please select TP Start Date",
                        },
                      ]}
                      initialValue={moment(
                        PrevPolDetails?.currentThirdPartyPolicy
                          ?.currentThirdPartyPolicyStartDateTime
                      )}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px 10px" }}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        placeholder="Select Expiry Date"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="TP Policy End Date"
                      name="tp_policy_end_date"
                      rules={[
                        {
                          required: true,
                          message: "Please select TP End Date",
                        },
                      ]}
                      initialValue={moment(
                        PrevPolDetails?.currentThirdPartyPolicy
                          ?.currentThirdPartyPolicyExpiryDateTime
                      )}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px 10px" }}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        placeholder="Select Expiry Date"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            ) : null}
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item style={{ textAlign: "center" }}>
                  {showStep4 ? null : (
                    <Button
                      loading={loading}
                      style={{ background: "#293890", border: "#293890" }}
                      type="primary"
                      htmlType="submit"
                    >
                      Submit
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
}

export { PreviousPolicyDetailCommer };
